import { IsBoolean, IsOptional, IsString } from "class-validator";

export class ProjectStatusDto {
  @IsString()
  text!: string;

  @IsString()
  icon!: string;

  @IsBoolean()
  @IsOptional()
  initial?: boolean;

  @IsString()
  scope!: string;
}
